module.exports = {"ENV_NAME":"local","LOG_ERRORS":true,"LOG_SENTRY":false}


//////////////////
// WEBPACK FOOTER
// ./src/config/local-deployment.json
// module id = 1248
// module chunks = 0